// The cache key for a reference lookup: its domain, plus any params that
// narrow it (a vehicle model list is per make).
//
// Shared by the fetcher and the label cache so a list is stored and read under
// exactly the same key — they used to derive it separately, which is the kind
// of duplication that silently stops matching the moment one side changes.

/**
 * @param {string} domain
 * @param {Record<string, string>} [params]
 * @returns {string}
 */
export const keyFor = (domain, params) => {
  const entries = Object.entries(params || {})
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .sort(([a], [b]) => a.localeCompare(b));
  return entries.length ? `${domain}?${new URLSearchParams(entries)}` : domain;
};
